import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeExerciseLoading,
  dispatch,
  setSuccessMessage,
  setErrorMessage,
  changeExercisePrimaryVideoLoading,
  changeExercisePrimaryVideoProgress,
  changeExerciseSecondaryVideoLoading,
  changeExerciseSecondaryVideoProgress,
  setExercisePrimaryVideoKey,
  setExerciseSecondaryVideoKey,
  addExerciseState,
  deleteExerciseState,
  setExerciseState,
  setExerciseById,
  editExerciseState,
  setCategoryState,
  setExerciseOptionState,
  setSessionFormatCategoryState,
  setExercisesByCategory,
  resetVideoProgressPrimary,
  setPrimaryVideoProgressState,
  setSecondaryVideoProgressState,
} from "../redux";

export const getExercise = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort,
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getExercises, {
      params: {
        page,
        limit,
        name: search,
        sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setExerciseState({ exercises: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const getOptions = async (refresh = false, query = "") => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getExerciseOption, {});

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setExerciseOptionState({ options: resp.data.result, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const getCategory = async (refresh = false, query = "") => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getExerciseCategory, {
      params: {
        limit: -1,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setCategoryState({ categories: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const getSessionFormatCategory = async (refresh = false, query = "") => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getSessionFormatCategory, {
      params: {
        limit: -1,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(
      setSessionFormatCategoryState({
        formatCategories: resp.data.results,
        refresh,
      }),
    );

    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const addSessionFormatCategory = async (formData) => {
  try {
    dispatch(changeExerciseLoading(true));
    const resp = await httpClient().post(ApiEndpoints.getSessionFormatCategory, {
      ...formData,
    });
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happened"));
    dispatch(changeExerciseLoading(false));
  }
};

export const deleteSessionFormatCategory = async (id) => {
  try {
    dispatch(changeExerciseLoading(true));
    const resp = await httpClient().delete(
      ApiEndpoints.getSessionFormatCategory + "/" + id,
    );
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happened"));
    dispatch(changeExerciseLoading(false));
  }
};

export const updateSessionFormatCategory = async (id, formData) => {
  try {
    dispatch(changeExerciseLoading(true));
    const resp = await httpClient().patch(
      ApiEndpoints.getSessionFormatCategory + "/" + id,
      {
        ...formData,
      }
    );
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happened"));
    dispatch(changeExerciseLoading(false));
  }
};

export const getExercisesByCategory = async (
  refresh = false,
  categoryId,
  page,
  limit,
  search = "",
  sort,
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getExercisesByCategory, {
      params: {
        category: categoryId,
        page,
        limit,
        name: search,
        sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(
      setExercisesByCategory({ exerciseCategory: resp.data.results, refresh }),
    );

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

export const addExercise = async (formData) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createExercise, {
      ...formData,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addExerciseState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

export const getExerciseById = async (id) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.exerciseById + "/" + id);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setExerciseById(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

export const editExercise = async (id, exerciseData) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.editExercise + "/" + id,
      { ...exerciseData },
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(editExerciseState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

export const deleteExercise = async (id) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.deleteExercise + "/" + id,
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteExerciseState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const uploadVideos = async (video, signal) => {
  try {
    // Set Loading
    dispatch(changeExercisePrimaryVideoLoading(true));

    // API Fetching
    const resp = await httpClient("multipart/form-data").post(
      ApiEndpoints.exercisePrimaryVideoUpload,
      { video },
      {
        signal,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );

          // Update progress in Redux
          if (percentCompleted)
            dispatch(changeExercisePrimaryVideoProgress(percentCompleted));
        },
      },
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSuccessMessage(resp.data.message));
    dispatch(setExercisePrimaryVideoKey(resp.data.result));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(changeExercisePrimaryVideoProgress(-1));
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExercisePrimaryVideoLoading(false));
  }
};
export const uploadVideoSecondary = async (video, signal) => {
  try {
    // Set Loading
    dispatch(changeExerciseSecondaryVideoLoading(true));

    // API Fetching
    const resp = await httpClient("multipart/form-data").post(
      ApiEndpoints.exerciseSecondaryVideoUpload,
      { video },
      {
        signal,

        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );

          // Call onProgress callback to update progress
          if (percentCompleted)
            dispatch(changeExerciseSecondaryVideoProgress(percentCompleted));
        },
      },
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSuccessMessage(resp.data.message));
    dispatch(setExerciseSecondaryVideoKey(resp.data.result));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(changeExerciseSecondaryVideoProgress(-1));
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseSecondaryVideoLoading(false));
  }
};

export const exerciseVideoDelete = async (id) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.exerciseVideoDelete + "/" + id,
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    dispatch(
      setPrimaryVideoProgressState({
        progress: 0,
        uploadState: false,
        videoKey: null,
      }),
    );

    // Show success message
    dispatch(setSuccessMessage(resp.data.message));
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happened"));
  } finally {
    dispatch(changeExerciseLoading(false)); // Stop loading in Redux
  }
};
export const exerciseVideoDeleteSecondary = async (id) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.exerciseVideoDelete + "/" + id,
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    dispatch(
      setSecondaryVideoProgressState({
        progress: 0,
        uploadState: false,
        videoKey: null,
      }),
    );

    // Show success message
    dispatch(setSuccessMessage(resp.data.message));
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happened"));
  } finally {
    dispatch(changeExerciseLoading(false)); // Stop loading in Redux
  }
};
